import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://ivsdhkghhfejebyrrenb.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml2c2Roa2doaGZlamVieXJyZW5iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjgyODUyNjgsImV4cCI6MjA0Mzg2MTI2OH0.dnLsE4yq9yxyEay_tMzrQhmzrE8N6NCH0vY157uUu28"
);
